<template>
  <v-form
    layout="column"
    class="full-width"
    :class="{'pa-2': !isSurvey, 'pa1-mobile': !isSurvey}"
    ref="form"
  >
    <template v-if="isEvent">
      <div
        layout="row"
        layout-wrap
      >
        <div
          layout="column"
          class="mr2-pc"
          :flex="$vuetify.breakpoint. smAndDown ? 100 : 50"
        >
          <div class="subheading font-weight-bold mb-3">{{$t('messages.banner')}}</div>
          <div
            layout="column"
            layout-align="center center"
          >
            <div
              @dragover.prevent
              @drop="dragBanner"
              @click.prevent="pickBanner"
              @keyup.enter="pickBanner"
              layout="column"
              layout-align="center center"
              class="upload-zone clickable text-truncate pa-1"
            >
              <span class="grey--text auto-break-text text-xs-center">{{$t('messages.banner_depos')}}</span>
            </div>
            <input
              type="file"
              style="display: none"
              ref="banner"
              accept="image/*"
              @change="onBannerPicked"
            />
          </div>
          <div
            v-if="banner && bannerUrl"
            layout="row"
            layout-align="center center"
            class="mt-2"
          >
            <div style="position: relative;">
              <span
                @click="deleteBanner"
                class="close"
              >&times;</span>
              <img
                :src="bannerUrl"
                :alt="banner.name"
                :title="banner.name"
                style="max-width: 100%; max-height: 150px"
              />
            </div>
          </div>
        </div>
        <div
          layout="column"
          class="ml2-pc"
          flex
        >
          <div class="subheading font-weight-bold mb-3">{{$t('messages.date')}}</div>
          <div
            layout="column"
            layout-align="center start"
            style="height: 100%"
          >
            <date-field
              @input="onStartInput"
              name="from"
              v-model="start"
              class="ml-1"
            />
          </div>
        </div>
      </div>
      <div class="subheading font-weight-bold mt-1 mt0-mobile">{{$t('messages.subject')}}</div>
      <v-text-field
        :label="$t('messages.subject_placeholder')"
        v-model="editingMessage.subject"
        single-line
        class="full-width"
        :rules="[ v => !!v || $t('errors.required') ]"
      ></v-text-field>
      <div class="subheading font-weight-bold mt-4 mt2-mobile mb-2">{{$t('messages.the_message')}}</div>
      <hr style="border: none; color: grey; background-color: grey; height: 1px" />
      <div>
        <v-textarea
          hide-details
          flat
          :placeholder="$t('messages.new_placeholder2')"
          class="full-width body-area"
          ref="body_ref"
          name="body_area"
          v-model="editingMessage.body"
          :rules="[ v => !!v || $t('errors.required') ]"
        ></v-textarea>
        <div
          layout="row"
          layout-align="start center"
        >
          <v-btn
            icon
            class="mx-0"
            @click.prevent.stop="toogleDialogEmoji"
          >
            <v-icon color="secondary">mdi-emoticon-happy-outline</v-icon>
          </v-btn>
          <v-btn
            icon
            class="mx-1"
            @click="docsDialog = true"
          >
            <v-badge
              right
              bottom
              overlap
              color="red"
              class="upload-badge"
            >
              <span
                v-if="documents.length"
                slot="badge"
                style="font-size: 10px"
              >{{documents.length}}</span>
              <v-icon color="secondary">mdi-paperclip</v-icon>
            </v-badge>
          </v-btn>
        </div>
        <div
          v-click-outside="closeEmoji"
          :hidden="dialogHidden"
          style="z-index: 250; position: absolute"
        >
          <VEmojiPicker
            :pack="emojisNative"
            labelSearch
            @select="onSelectEmoji"
          />
        </div>
      </div>
      <div
        layout="row"
        layout-align="end center"
        class="mt-2"
      >
        <v-btn
          depressed
          color="secondary"
          @click="save"
          style="text-transform: none"
          :disabled="loading"
        >{{$t('_.send')}}</v-btn>
        &nbsp;{{$t('_.or')}}&nbsp;&nbsp;
        <a
          href="#"
          class="black--text"
          @click.prevent="cancel"
        >{{$t('_.cancel')}}</a>
      </div>
    </template>
    <template v-else>
      <template v-if="!isSurvey && !isDoc && (editingMessage.type != Consts.REPLY)">
        <div class="subheading font-weight-bold mb3-pc">{{$t('messages.compose')}}</div>
        <v-radio-group
          v-model="editingMessage.type"
          color="secondary"
          :rules="[ v => !!v || $t('errors.required') ]"
          class="mt-0"
          :row="!$vuetify.breakpoint.smAndDown"
          hide-details
          v-if="!isPrivate && !isCircle"
        >
          <template v-for="t in typesCompose">
            <v-radio
              :key="'composetype'+t.value"
              :label="t.text"
              :value="t.value"
              v-if="t.condition"
              class="mb-0"
            ></v-radio>
          </template>
        </v-radio-group>
        <div
          v-if="editingMessage.type == Consts.TOPDOWN"
          class="caption grey--text"
        >{{$t('messages.topdown_hint')}}</div>
        <div
          v-else-if="editingMessage.type == Consts.BOTTOMUP"
          class="caption grey--text"
        >{{$t('messages.bottomup_hint')}}</div>
        <div
          v-else-if="editingMessage.type == Consts.HORIZONTAL"
          class="caption grey--text"
        >{{$t('messages.horizontal_hint')}}</div>
        <div v-if="levelsCompose && levelsCompose.length">
          <div class="subheading font-weight-bold mt-3 mb-2">{{$t('messages.for_lv')}}</div>
          <div
            layout="row"
            layout-align="start center"
            layout-wrap
          >
            <v-checkbox
              v-for="l in levelsCompose"
              hide-details
              :label="l.text"
              :value="l.value"
              v-model="editingMessage.levels_ids"
              :key="`levelmessage_${l.value}`"
              class="mt-0 pt-0 mr-4"
              style="flex: none"
              :readonly="(levelsCompose.length > 1) ? false : true"
              :rules="[ v => (!!v && !!v.length) || $t('errors.required') ]"
            ></v-checkbox>
          </div>
        </div>
        <div v-if="(editingMessage.type == Consts.CIRCLE) && !isCircle">
          <div class="subheading font-weight-bold mt-3 mb-2">{{$t('messages.refine')}}</div>
          <div
            layout="row"
            layout-align="start center"
            layout-wrap
          >
            <v-select
              :label="$t('nav.circles')"
              :hint="$t('filters.circles_select')"
              persistent-hint
              multiple
              solo
              v-model="editingMessage.circles_ids"
              :items="circles"
              item-text="name"
              item-value="id"
              class="mt-0 pt-0"
            ></v-select>
          </div>
        </div>
        <div v-if="isRefinable">
          <div class="subheading font-weight-bold mt-3">{{$t('messages.refine')}}</div>
          <div
            layout="row"
            layout-wrap
            class="full-width pa-1"
          >
            <div
              layout="column"
              :flex="$vuetify.breakpoint. smAndDown ? 100 : 50"
              class="mt2-pc"
            >
              <v-select
                :label="$t('params.sectors')"
                :hint="$t('filters.sectors_select')"
                persistent-hint
                multiple
                solo
                v-model="editingMessage.sectors_ids"
                :items="sectors"
                class="mr5-pc width-100-mobile"
              ></v-select>
            </div>
            <div
              layout="column"
              :flex="$vuetify.breakpoint.smAndDown ? 100 : 50"
              class="mt2-pc"
            >
              <v-select
                :label="$t('params.rds')"
                :hint="$t('filters.rds_select')"
                persistent-hint
                multiple
                solo
                autocomplete
                v-model="editingMessage.regional_directorates_ids"
                :items="rds"
                item-value="id"
                :item-text="itemLabel"
                class="ml5-pc width-100-mobile"
              ></v-select>
            </div>
            <div
              layout="column"
              :flex="$vuetify.breakpoint.smAndDown ? 100 : 50"
              class="mt2-pc"
            >
              <v-select
                :label="$t('params.regions')"
                :hint="$t('filters.regions_select')"
                persistent-hint
                multiple
                solo
                autocomplete
                v-model="editingMessage.regions_ids"
                :items="regions"
                item-value="id"
                :item-text="itemName"
                class="mr5-pc width-100-mobile"
              ></v-select>
            </div>
            <div
              layout="column"
              :flex="$vuetify.breakpoint.smAndDown ? 100 : 50"
              class="mt2-pc"
            >
              <v-select
                :label="$t('params.cities')"
                :hint="$t('filters.cities_select')"
                persistent-hint
                multiple
                solo
                autocomplete
                v-model="editingMessage.cities_ids"
                :items="$store.state.cities"
                item-value="id"
                item-text="label"
                class="ml5-pc width-100-mobile"
              ></v-select>
            </div>
            <div
              layout="column"
              :flex="$vuetify.breakpoint. smAndDown ? 100 : 50"
              class="mt2-pc"
            >
              <v-select
                :label="$t('schools.title')"
                :hint="$t('filters.schools_select')"
                persistent-hint
                multiple
                solo
                autocomplete
                v-model="editingMessage.schools_ids"
                :items="schools"
                item-value="id"
                item-text="name"
                class="mr5-pc width-100-mobile"
              ></v-select>
            </div>
          </div>
        </div>
        <div
          class="subheading font-weight-bold mt-1 mt0-mobile"
          v-if="!isPrivate"
        >{{$t('messages.subject')}}</div>
        <v-text-field
          :label="$t('messages.subject_placeholder')"
          v-model="editingMessage.subject"
          single-line
          class="full-width"
          :rules="[ v => !!v || $t('errors.required') ]"
          v-if="!isPrivate"
        ></v-text-field>
      </template>
      <div
        class="subheading font-weight-bold mt-3 mt2-mobile mb-2"
        v-if="!isPrivate"
      >
        <template v-if="editingMessage.type == Consts.REPLY">{{$t('messages.reply_title')}} {{editingMessage.from}}</template>
        <template v-else-if="isSurvey">{{$t('surveys.pres_mess')}}</template>
        <template v-else>{{$t('messages.the_message')}}</template>
      </div>
      <hr style="border: none; color: grey; background-color: grey; height: 1px" />
      <div>
        <v-textarea
          hide-details
          flat
          :placeholder="isSurvey ? $t('messages.new_placeholder') : $t('messages.new_placeholder2')"
          class="full-width body-area"
          ref="body_ref"
          name="body_area"
          v-model="editingMessage.body"
          :rules="[ v => !!v || $t('errors.required') ]"
        ></v-textarea>
        <div
          layout="row"
          layout-align="start center"
        >
          <v-btn
            icon
            class="mx-0"
            @click.prevent.stop="toogleDialogEmoji"
          >
            <v-icon color="secondary">mdi-emoticon-happy-outline</v-icon>
          </v-btn>
          <v-btn
            v-if="!isDoc"
            icon
            class="mx-1"
            @click="docsDialog = true"
          >
            <v-badge
              right
              bottom
              overlap
              color="red"
              class="upload-badge"
            >
              <span
                v-if="documents.length"
                slot="badge"
                style="font-size: 10px"
              >{{documents.length}}</span>
              <v-icon color="secondary">mdi-paperclip</v-icon>
            </v-badge>
          </v-btn>
          <v-btn
            v-if="!isDoc"
            icon
            class="mx-0"
            @click="mediasDialog = true"
          >
            <v-badge
              right
              bottom
              overlap
              color="red"
              class="upload-badge"
            >
              <span
                v-if="medias.length"
                slot="badge"
                style="font-size: 10px"
              >{{medias.length}}</span>
              <v-icon color="secondary">mdi-image</v-icon>
            </v-badge>
          </v-btn>
        </div>
        <div
          v-click-outside="closeEmoji"
          :hidden="dialogHidden"
          style="z-index: 250; position: absolute"
        >
          <VEmojiPicker
            :pack="emojisNative"
            labelSearch
            @select="onSelectEmoji"
          />
        </div>
      </div>
      <div
        v-if="!isDoc && !isSurvey"
        layout="row"
        layout-align="end center"
        class="mt-2"
      >
        <v-btn
          depressed
          color="secondary"
          @click="save"
          style="text-transform: none"
          :disabled="loading"
        >{{$t('_.send')}}</v-btn>
        <div v-if="!isPrivate">
          &nbsp;{{$t('_.or')}}&nbsp;&nbsp;
          <a
            href="#"
            class="black--text"
            @click.prevent="cancel"
          >{{$t('_.cancel')}}</a>
        </div>
      </div>
    </template>
    <v-dialog
      v-model="docsDialog"
      max-width="700"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card>
        <v-card-title class="title">
          <v-icon
            color="secondary"
            class="mr-2"
          >mdi-paperclip</v-icon>
          {{$t('messages.add_docs')}}
          <v-spacer></v-spacer>
          <v-btn
            class="ma-0"
            icon
            @click="docsDialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div
            layout="column"
            layout-align="center center"
          >
            <div
              @dragover.prevent
              @drop="dragDoc"
              @click.prevent="pickDoc"
              @keyup.enter="pickDoc"
              layout="column"
              layout-align="center center"
              class="upload-zone clickable text-truncate pa-1"
            >
              <span class="grey--text auto-break-text text-xs-center">{{$t('messages.doc_depos')}}</span>
            </div>
            <input
              type="file"
              style="display: none"
              ref="doc"
              @change="onDocPicked"
              multiple
            />
          </div>
          <v-data-table
            v-if="documents && documents.length"
            :items="documents"
            hide-actions
            hide-headers
            class="full-width mt-4"
          >
            <template
              slot="items"
              slot-scope="props"
            >
              <td width="30">
                <v-icon>mdi-paperclip</v-icon>
              </td>
              <td>{{ props.item.id ? props.item.document.name : props.item.name }}</td>
              <td width="30">
                <v-btn
                  @click="deleteDoc(props.index)"
                  class="mx-0"
                  icon
                >
                  <v-icon color="red">mdi-close</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="secondary"
            @click="docsDialog = false"
            style="text-transform: none"
          >{{$t('_.validate')}}</v-btn>
          &nbsp;{{$t('_.or')}}&nbsp;
          <a
            @click.prevent="docsDialog = false"
            href="#"
            class="black--text"
          >{{$t('_.cancel')}}</a>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="mediasDialog"
      max-width="700"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card>
        <v-card-title class="title">
          <div
            layout="row"
            layout-align="start center"
            class="full-width"
          >
            <v-icon
              color="secondary"
              class="mr-2"
            >mdi-image</v-icon>
            <div
              layout="row"
              layout-align="start center"
              layout-wrap
            >{{$t('messages.add_medias')}}</div>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-0"
              icon
              @click="mediasDialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <div layout="row">
            <div layout="column">
              <v-icon color="red">mdi-alert-circle</v-icon>
            </div>
            <div
              layout="column"
              class="ml-2"
            >
              <p>
                <b>{{$t('messages.warning_media')}}</b>&nbsp;
                <span>{{$t('messages.warning_media_info')}}</span>
              </p>
            </div>
          </div>
          <div
            layout="column"
            layout-align="center center"
          >
            <div
              @dragover.prevent
              @drop="drag"
              @click.prevent="pickMedia"
              @keyup.enter="pickMedia"
              layout="column"
              layout-align="center center"
              class="upload-zone clickable text-truncate pa-1"
            >
              <span class="grey--text auto-break-text text-xs-center">{{$t('messages.media_depos')}}</span>
            </div>
            <input
              type="file"
              style="display: none"
              ref="media"
              accept="video/mp4, video/x-m4v, image/*, video/*"
              @change="onMediaPicked"
              multiple
            />
          </div>
          <div
            layout="row"
            layout-align="start center"
            layout-wrap
            class="mt-4"
          >
            <template v-for="(m,i) in medias">
              <div
                :key="'media_'+i"
                v-if="mediasUrls[i]"
                class="mr-2 mb-2"
                style="position: relative"
              >
                <span
                  @click="deleteMedia(i)"
                  class="close"
                >&times;</span>
                <video
                  v-if="isVideo(m.type, mediasUrls[i])"
                  :src="mediasUrls[i]"
                  :alt="m.name"
                  :title="m.name"
                  style="max-width: 100px; max-height: 100px"
                  muted
                  loop
                ></video>
                <img
                  v-else
                  :src="mediasUrls[i]"
                  :alt="m.name"
                  :title="m.name"
                  style="max-width: 100px; max-height: 100px"
                />
              </div>
            </template>
          </div>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="secondary"
            @click="mediasDialog = false"
            style="text-transform: none"
          >{{$t('_.validate')}}</v-btn>
          &nbsp;{{$t('_.or')}}&nbsp;
          <a
            @click.prevent="mediasDialog = false"
            href="#"
            class="black--text"
          >{{$t('_.cancel')}}</a>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>
<script>
import VEmojiPicker from "v-emoji-picker"
import packData from "v-emoji-picker/data/emojis.js"
import DateField from "@/components/shared/DateField"
import Auth from "@/plugins/auth"
import I18nMixin from "@/mixins/i18n"
import Consts from "@/consts"
import Params from "@/api/params"
import Schools from "@/api/schools"
import axios from "axios"

export default {
  mixins: [I18nMixin],
  components: { VEmojiPicker, DateField },
  props: {
    value: {
      type: Object,
      required: false,
      default: () => { }
    },
    isEvent: {
      type: Boolean,
      default: false,
    },
    isDoc: {
      type: Boolean,
      default: false,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    isPrivate: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data () {
    return {
      medias: [],
      mediasUrls: [],
      deletedMedias: [],
      documents: [],
      deletedDocs: [],
      banner: null,
      bannerUrl: null,
      start: "",
      rds: [],
      regions: [],
      schools: [],
      dialogHidden: true,
      docsDialog: false,
      mediasDialog: false,
      Consts
    }
  },
  mounted () {
    if (!this.isNew) {
      if (this.editingMessage.type == Consts.EVENT) {
        this.start = this.editingMessage.date_start

        if (this.editingMessage.banner_id) {
          axios.get("/assets/event/" + this.editingMessage.id).then(res => {
            this.banner = {}
            this.bannerUrl = res.data
          })
        }

        for (let i = 0; i < this.editingMessage.medias.length; i++) {
          axios
            .get("/assets/messageMedias/" + this.editingMessage.medias[i].id)
            .then(res => {
              this.medias.push(this.editingMessage.medias[i])
              this.mediasUrls.push(res.data)
            })
        }

        for (let i = 0; i < this.editingMessage.documents.length; i++) {
          this.documents.push(this.editingMessage.documents[i])
        }
      } else if (!this.isDoc) {
        if (!this.isSurvey && this.editingMessage.type !== Consts.REPLY) {
          this.fetchParams()
        }

        for (let i = 0; i < this.editingMessage.medias.length; i++) {
          axios
            .get("/assets/messageMedias/" + this.editingMessage.medias[i].id)
            .then(res => {
              this.medias.push(this.editingMessage.medias[i])
              this.mediasUrls.push(res.data)
            })
        }

        for (let i = 0; i < this.editingMessage.documents.length; i++) {
          this.documents.push(this.editingMessage.documents[i])
        }
      }
    } else if (this.editingMessage.type != Consts.REPLY) {
      // Pour les réponses on garde les mêmes filtres que l'original
      this.fetchParams()
    }
  },
  watch: {
    levelsCompose (val) {
      if (!this.editingMessage.id && val && val.length) {
        this.editingMessage.levels_ids = [val[0].value]
      }
    },
  },
  computed: {
    editingMessage: {
      get () {
        return this.value
      },
      set (x) {
        this.$emit("update:value", x)
      }
    },
    isNew () {
      return !this.editingMessage.id
    },
    isSurvey () {
      if (this.editingMessage.type == Consts.SURVEY) {
        return true
      }

      return false
    },
    isRefinable () {
      if (
        this.editingMessage.type == Consts.TOPDOWN ||
        this.editingMessage.type == Consts.BOTTOMUP ||
        this.editingMessage.type == Consts.HORIZONTAL
      ) {
        return true
      }
      return false
    },
    emojisNative () {
      return packData
    },
    mediasSize () {
      let sum = 0
      for (let i = 0; i < this.medias.length; i++) {
        const f = this.medias[i]
        if (f.size) {
          sum += f.size
        }
      }
      return sum
    },
    docsSize () {
      let sum = 0
      for (let i = 0; i < this.documents.length; i++) {
        const f = this.documents[i]
        if (f.size) {
          sum += f.size
        }
      }
      return sum
    },
    bannerSize () {
      if (this.banner && this.banner.size) {
        return this.banner.size
      }
      return 0
    },
    typesCompose () {
      return [
        {
          value: Consts.CIRCLE,
          text: this.$t("messages.my_circle"),
          condition: true,
        },
        {
          value: Consts.PLATFORM,
          text: this.$t("messages.all_platform"),
          condition: !this.circle,
        },
        {
          value: Consts.TOPDOWN,
          text: "top-down",
          condition: !this.isLocal && !this.circle,
        },
        {
          value: Consts.BOTTOMUP,
          text: "bottom-up",
          condition: !this.isMinistry && !this.circle,
        },
        {
          value: Consts.HORIZONTAL,
          text: this.$t("messages.horizontal"),
          condition: !this.circle
        }
      ]
    },
    levelsCompose () {
      let lvs = []
      switch (this.editingMessage.type) {
        case Consts.TOPDOWN:
          switch (Auth.user.level) {
            case Consts.LOCAL:
              lvs = []
              break
            case Consts.SECTORAL:
              lvs = [{ value: Consts.LOCAL, text: this.$t("users.lv_loc") }]
              break
            case Consts.NATIONAL:
              lvs = [
                { value: Consts.SECTORAL, text: this.$t("users.lv_sec") },
                { value: Consts.LOCAL, text: this.$t("users.lv_loc") },
              ]
              break
            default:
              lvs = [
                { value: Consts.NATIONAL, text: this.$t("users.lv_nat") },
                { value: Consts.SECTORAL, text: this.$t("users.lv_sec") },
                { value: Consts.LOCAL, text: this.$t("users.lv_loc") },
              ]
              break
          }
          break
        case Consts.BOTTOMUP:
          switch (Auth.user.level) {
            case Consts.LOCAL:
              lvs = [{ value: Consts.SECTORAL, text: this.$t("users.lv_sec") }]
              break
            case Consts.SECTORAL:
              lvs = [{ value: Consts.NATIONAL, text: this.$t("users.lv_nat") }]
              break
            case Consts.NATIONAL:
              lvs = [{ value: Consts.MINISTRY, text: this.$t("users.lv_min") }]
              break
            default:
              lvs = []
              break
          }
          break
        case Consts.HORIZONTAL:
          switch (Auth.user.level) {
            case Consts.LOCAL:
              lvs = [{ value: Consts.LOCAL, text: this.$t("users.lv_loc") }]
              break
            case Consts.SECTORAL:
              lvs = [{ value: Consts.SECTORAL, text: this.$t("users.lv_sec") }]
              break
            case Consts.NATIONAL:
              lvs = [{ value: Consts.NATIONAL, text: this.$t("users.lv_nat") }]
              break
            default:
              lvs = [{ value: Consts.MINISTRY, text: this.$t("users.lv_min") }]
              break
          }
          break
      }
      return lvs
    },
    sectors () {
      return [
        { value: Consts.PRIMARY, text: this.$t("schools.sector_prim") },
        { value: Consts.SECONDARY, text: this.$t("schools.sector_sec") },
        { value: Consts.COMPETENCECENTRE, text: this.$t("schools.sector_comp") }
      ]
    },
    circles () {
      var res = JSON.parse(JSON.stringify(this.$store.state.circles))

      res.unshift({ id: null, name: this.$t('circles.default') })

      return res
    },
    isCircle () {
      if (this.$route.name === 'circles-show') {
        return true
      }
      if (this.$route.name === 'my-circle') {
        return true
      }

      return false
    }
  },
  methods: {
    reset () {
      this.medias = []
      this.mediasUrls = []
      this.deletedMedias = []
      this.documents = []
      this.deleteDoc = []
      this.banner = null
      this.deleteBanner = null
    },
    itemLabel (item) {
      return this.i18n(item.label)
    },
    itemName (item) {
      return this.i18n(item.name)
    },
    fetchParams () {
      Schools.getList({
        sortBy: "name",
        is_enabled: 1,
        current_id: this.editingMessage.schools_ids.length
          ? this.editingMessage.schools_ids
          : null
      }).then(res => {
        this.schools = res.data
      })
      Params.getList("regional-directorates", {
        is_enabled: 1,
        current_id: this.editingMessage.regional_directorates_ids.length
          ? this.editingMessage.regional_directorates_ids
          : null
      }).then(res => {
        this.rds = res.data
        this.rds = this.rds.sort((a, b) =>
          this.i18n(a.label) > this.i18n(b.label)
            ? 1
            : this.i18n(b.label) > this.i18n(a.label)
              ? -1
              : 0
        )
      })
      Params.getList("regions", {
        is_enabled: 1,
        current_id: this.editingMessage.regions_ids.length
          ? this.editingMessage.regions_ids
          : null
      }).then(res => {
        this.regions = res.data
        this.regions = this.regions.sort((a, b) =>
          this.i18n(a.name) > this.i18n(b.name)
            ? 1
            : this.i18n(b.name) > this.i18n(a.name)
              ? -1
              : 0
        )
      })
    },
    pickBanner () {
      this.$refs.banner.click()
    },
    dragBanner (e) {
      e.stopPropagation()
      e.preventDefault()
      var files = e.dataTransfer.files
      if (files[0] !== undefined) {
        const f = files[0]
        if (f.size + this.docsSize + this.mediasSize > Auth.user.upload_limit) {
          this.$snotify.error(this.$t("_.file_limit"))
          return
        }
        this.banner = f
        const u = URL.createObjectURL(f)
        this.bannerUrl = u
      }
      e.target.value = ""
    },
    onBannerPicked (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        const f = files[0]
        if (f.size + this.docsSize + this.mediasSize > Auth.user.upload_limit) {
          this.$snotify.error(this.$t("_.file_limit"))
          return
        }
        this.banner = f
        const u = URL.createObjectURL(f)
        this.bannerUrl = u
      }
      e.target.value = ""
    },
    deleteBanner () {
      this.banner = null
      this.bannerUrl = null
      this.editingMessage.banner_id = ""
    },
    pickDoc () {
      this.$refs.doc.click()
    },
    dragDoc (e) {
      e.stopPropagation()
      e.preventDefault()
      var files = e.dataTransfer.files
      for (let i = 0; i < files.length; i++) {
        if (files[i] !== undefined) {
          const f = files[i]
          if (
            f.size + this.docsSize + this.mediasSize + this.bannerSize >
            Auth.user.upload_limit
          ) {
            this.$snotify.error(this.$t("_.files_limit"))
            break
          }
          this.documents.push(f)
        }
      }
      e.target.value = ""
    },
    onDocPicked (e) {
      const files = e.target.files
      for (let i = 0; i < files.length; i++) {
        if (files[i] !== undefined) {
          const f = files[i]
          if (
            f.size + this.docsSize + this.mediasSize + this.bannerSize >
            Auth.user.upload_limit
          ) {
            this.$snotify.error(this.$t("_.files_limit"))
            break
          }
          this.documents.push(f)
        }
      }
      e.target.value = ""
    },
    deleteDoc (i) {
      if (this.documents[i].id) {
        this.deletedDocs.push(this.documents[i].id)
      }
      this.documents.splice(i, 1)
    },
    pickMedia () {
      this.$refs.media.click()
    },
    drag (e) {
      e.stopPropagation()
      e.preventDefault()
      var files = e.dataTransfer.files
      for (let i = 0; i < files.length; i++) {
        if (files[i] !== undefined) {
          const f = files[i]
          if (
            f.size + this.docsSize + this.mediasSize + this.bannerSize >
            Auth.user.upload_limit
          ) {
            this.$snotify.error(this.$t("_.files_limit"))
            break
          }
          this.medias.push(f)
          const u = URL.createObjectURL(f)
          this.mediasUrls.push(u)
        }
      }
      e.target.value = ""
    },
    onMediaPicked (e) {
      const files = e.target.files
      for (let i = 0; i < files.length; i++) {
        if (files[i] !== undefined) {
          const f = files[i]
          if (
            f.size + this.docsSize + this.mediasSize + this.bannerSize >
            Auth.user.upload_limit
          ) {
            this.$snotify.error(this.$t("_.files_limit"))
            break
          }
          this.medias.push(f)
          const u = URL.createObjectURL(f)
          this.mediasUrls.push(u)
        }
      }
      e.target.value = ""
    },
    isVideo (type, data) {
      if (type) {
        if (type.indexOf("video/") == 0) {
          return true
        }
        return false
      } else {
        if (data.indexOf("data:video/") == 0) {
          return true
        }
        return false
      }
    },
    deleteMedia (i) {
      if (this.medias[i].id) {
        this.deletedMedias.push(this.medias[i].id)
      }
      this.medias.splice(i, 1)
      this.mediasUrls.splice(i, 1)
    },
    onStartInput (val) {
      this.editingMessage.date_start = val
    },
    toogleDialogEmoji () {
      this.dialogHidden = !this.dialogHidden
      if (!this.dialogHidden) {
        this.$refs.body_ref.focus()
      }
    },
    closeEmoji: function () {
      this.dialogHidden = true
    },
    onSelectEmoji (dataEmoji) {
      let value = dataEmoji.emoji

      let textArea = document.getElementsByName("body_area")[0]
      let startPos = textArea.selectionStart,
        // get cursor's position:
        endPos = textArea.selectionEnd,
        cursorPos = startPos,
        tmpStr = textArea.value

      if (value === null) {
        return
      }

      // insert:
      this.editingMessage.body =
        tmpStr.substring(0, startPos) +
        value +
        tmpStr.substring(endPos, tmpStr.length)

      // move cursor:
      setTimeout(() => {
        cursorPos += value.length
        textArea.selectionStart = textArea.selectionEnd = cursorPos
        this.$refs.body_ref.focus()
      }, 10)
    },
    cancel () {
      this.$emit("cancel")
    },
    save () {
      const data = {
        deletedDocs: this.deletedDocs,
        deletedMedias: this.deletedMedias,
        medias: this.medias,
        documents: this.documents,
        banner: this.banner
      }

      // Pas besoin du filtre en BE si on vise le cercle par défaut
      if (this.editingMessage.circles_ids == [null]) {
        this.editingMessage.splice(0, 1)
      }

      this.$emit("save", data)
    }
  },
  directives: {
    "click-outside": {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // here I check that click was outside the el and his childrens
          if (!(el == event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener("click", el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener("click", el.clickOutsideEvent)
      }
    }
  }
};
</script>
<style>
.date-field
  > .v-input__control
  > .v-input__slot
  > .v-text-field__slot
  > .v-label {
  font-size: 14px;
  line-height: 18px;
  top: 14px;
}

.date-field > .v-input__control > .v-input__slot > .v-text-field__slot {
  font-size: 14px;
}

.date-field > .v-input__control > .v-input__slot > .v-text-field__slot > input {
  margin-top: 7px;
}

.date-field.v-text-field > .v-input__append-outer {
  margin-top: 12px;
}

.date-field > .v-input__control > .v-input__slot {
  min-height: 46px;
}
.body-area > .v-input__control > .v-input__slot {
  padding-bottom: 16px;
}
.upload-badge > .v-badge__badge {
  height: 17px;
  width: 17px;
}
</style>
<style scoped>
@media screen and (min-width: 960px) {
  .upload-zone {
    width: 50%;
  }
}
.upload-zone {
  height: 150px;
  border: 2px dashed grey;
  border-radius: 7% 7%;
}
@media screen and (max-width: 960px) {
  .upload-zone {
    width: 90%;
  }
}
.close {
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 100;
  color: white;
  text-shadow: red 0.1em 0.1em 0.2em;
  cursor: pointer;
  border-radius: 50% 50%;
  background-color: red;
  width: 14px;
  text-align: center;
  vertical-align: middle;
  line-height: 1;
}
</style>